import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { getCampaignById } from '../../utils/api/campaignAPI';
import { convertToIndianTimeZone } from '../../utils/utils';

function ViewCampaignModal({ id, show, onClose }) {
  const [campaign, setCampaign] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id || !show) return;

    setLoading(true);
    getCampaignById(id)
      .then((res) => {
        setCampaign(res?.campaign || null);
      })
      .catch((e) => {
        console.error('Error fetching campaign:', e);
        setCampaign(null);
      })
      .finally(() => setLoading(false));
  }, [id, show]);

  if (!show) return null;

  return (
    <motion.div
      className="modal fade show"
      tabIndex="-1"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      style={{
        display: 'block',
        backgroundColor: 'rgba(0,0,0,0.6)',
        backdropFilter: 'blur(4px)',
        zIndex: 1050,
      }}
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content" style={{ borderRadius: '16px', border: 'none' }}>
          <div className="modal-header">
            <h6 className="modal-title">Campaign Details</h6>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>

          <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
            {loading ? (
              <div className="text-center flex gap-10">
                {Array.from({ length: 5 }).map((_, i) => (
                  <div
                    key={i}
                    className="shimmer shimmer-text"
                    style={{ width: '120px', height: '2.5rem', margin: 'auto' }}
                  />
                ))}
              </div>
            ) : campaign ? (
              <div className="row g-3">
                <div className="col-12">
                  <label className="form-label fw-semibold">Campaign Name</label>
                  <div className="form-control">{campaign.name || '-'}</div>
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Assistant</label>
                  <div className="form-control">
                    {campaign.assistant?.name || campaign.assistantId || '-'}
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Phone Number</label>
                  <div className="form-control">
                    {campaign.phoneNumber?.did || campaign.phoneNumberId || '-'}
                  </div>
                </div>

                <div className="col-12">
                  <label className="form-label fw-semibold">Customers ({campaign.customers?.length || 0})</label>
                  {campaign.customers && campaign.customers.length > 0 ? (
                    <div className="border rounded">
                      <div className="table-responsive" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                        <table className="table table-sm mb-0">
                          <thead className="table-light sticky-top">
                            <tr>
                              <th style={{ width: '50px' }}>S.No</th>
                              <th>Phone Number</th>
                              <th>E164 Check</th>
                            </tr>
                          </thead>
                          <tbody>
                            {campaign.customers.map((customer, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{customer.number || '-'}</td>
                                <td>
                                  <span className={`badge ${customer.numberE164CheckEnabled ? 'bg-success' : 'bg-secondary'}`}>
                                    {customer.numberE164CheckEnabled ? 'Enabled' : 'Disabled'}
                                  </span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    <div className="form-control text-muted">No customers added</div>
                  )}
                </div>

                {campaign.schedulePlan && (
                  <div className="col-12">
                    <label className="form-label fw-semibold">Schedule Plan</label>
                    <div className="form-control">
                      {campaign.schedulePlan.earliestAt
                        ? convertToIndianTimeZone(campaign.schedulePlan.earliestAt)
                        : '-'}
                    </div>
                  </div>
                )}

                

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Campaign ID</label>
                  <div className="form-control" style={{ fontSize: '12px', wordBreak: 'break-all' }}>
                    {campaign.id || '-'}
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Created At</label>
                  <div className="form-control">
                    {campaign.createdAt ? convertToIndianTimeZone(campaign.createdAt) : '-'}
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Updated At</label>
                  <div className="form-control">
                    {campaign.updatedAt ? convertToIndianTimeZone(campaign.updatedAt) : '-'}
                  </div>
                </div>
              </div>
            ) : (
              <div className="text-danger text-center py-4">
                Campaign not found or failed to load.
              </div>
            )}
          </div>

          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default ViewCampaignModal;

